module.exports = __webpack_public_path__ + "media/images/flags/1x1/fin-1e50233033cf752cebd4af06ed2149b0.svg";